import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class DashboardReviApi {
  constructor() {
    this.baseApi = ENV.BASE_API; // .../api/v1
  }

  async getSummary(token, { timeRange = "last_30_days" } = {}) {
    const url = `${this.baseApi}/revi/dashboard/summary?timeRange=${encodeURIComponent(timeRange)}`;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200)
      throw new Error(json?.message || "Error cargando summary");
    return json;
  }

  async getCharts(token, { timeRange = "last_30_days" } = {}) {
    // Si tu backend aún no usa timeRange en charts, no rompe: simplemente lo ignorará.
    const url = `${this.baseApi}/revi/dashboard/charts?timeRange=${encodeURIComponent(timeRange)}`;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200)
      throw new Error(json?.message || "Error cargando charts");
    return json;
  }

  async getActivity(token, { timeRange = "last_30_days" } = {}) {
    // Si tu backend aún no usa timeRange en activity, no rompe: simplemente lo ignorará.
    const url = `${this.baseApi}/revi/dashboard/activity?timeRange=${encodeURIComponent(timeRange)}`;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200)
      throw new Error(json?.message || "Error cargando activity");
    return json;
  }

  async exportEvaluationsCsv(token, { timeRange = "last_30_days" } = {}) {
    const url = `${this.baseApi}/revi/dashboard/export/evaluations?timeRange=${encodeURIComponent(timeRange)}`;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    if (!response.ok) {
      const json = await response.json().catch(() => ({}));
      throw new Error(json?.message || "Error exportando");
    }

    const blob = await response.blob();
    const cd = response.headers.get("content-disposition") || "";
    const match = cd.match(/filename="([^"]+)"/);
    const filename = match?.[1] || "revi_evaluaciones.csv";

    return { blob, filename };
  }
}
